import { IonModal } from '@ionic/react'
import React, { FC } from 'react'
import './index.scss'

interface IProps {
  message: string;
  cancelText?: string;
  okText?: string;
  reject?: any;
  resolve?: any;
}

const ClearModal: FC<IProps> = ({ message, cancelText, okText, reject, resolve }) => {
  return (
    <IonModal
      cssClass='clear-modal'
      isOpen
    >
      <div className='clear-modal-content'>
        <div className='message'>{message}</div>
        <div>
          <div className='btn-cancel' data-cypid='clearModalClose' onClick={reject}>{cancelText || i18n.t('common.cancel')}</div>
          <div className='btn-ok' data-cypid='clearModalConfirm' onClick={resolve}>{okText || i18n.t('common.ok')}</div>
        </div>
      </div>
    </IonModal>
  )
}

export default ClearModal
